// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.costSavingCalculationInputWrapper__Szj4V {
  display: flex;
  align-items: center;
  gap: 30px;
}

.inputContainer__L7_8J {
  width: 200px;
}
@media (max-width: 1024px) {
  .inputContainer__L7_8J {
    width: 160px;
  }
}

.rightSideWrapper__XNtsi {
  display: flex;
  align-items: center;
}

.actionsBlock__bPVQr {
  display: flex;
  gap: 10px;
}

.separator__Jr2Cm {
  height: 35px;
  width: 1px;
  background: var(--tables-primary-row-stroke);
}

.startAdornment__Oh5jH {
  color: var(--inputs-filled-text);
}`, "",{"version":3,"sources":["webpack://./../src/pages/MultiplicationFactors/components/CostSavingCalculationInput/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAzEF;;AA4EA;EACE,YAAA;AAzEF;AA2EE;EAHF;IAII,YAAA;EAxEF;AACF;;AA2EA;EACE,aAAA;EACA,mBAAA;AAxEF;;AA2EA;EACE,aAAA;EACA,SAAA;AAxEF;;AA2EA;EACE,YAAA;EACA,UAAA;EACA,4CAAA;AAxEF;;AA2EA;EACE,gCAAA;AAxEF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.costSavingCalculationInputWrapper {\n  display: flex;\n  align-items: center;\n  gap: 30px;\n}\n\n.inputContainer {\n  width: 200px;\n\n  @media (max-width: 1024px) {\n    width: 160px;\n  }\n}\n\n.rightSideWrapper {\n  display: flex;\n  align-items: center;\n}\n\n.actionsBlock {\n  display: flex;\n  gap: 10px;\n}\n\n.separator {\n  height: 35px;\n  width: 1px;\n  background: var(--tables-primary-row-stroke);\n}\n\n.startAdornment {\n  color: var(--inputs-filled-text);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"costSavingCalculationInputWrapper": `costSavingCalculationInputWrapper__Szj4V`,
	"inputContainer": `inputContainer__L7_8J`,
	"rightSideWrapper": `rightSideWrapper__XNtsi`,
	"actionsBlock": `actionsBlock__bPVQr`,
	"separator": `separator__Jr2Cm`,
	"startAdornment": `startAdornment__Oh5jH`
};
module.exports = ___CSS_LOADER_EXPORT___;
